import React from 'react';
import './AboutUs.css';

import { Banner, PageTitle, VenueDetails } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, SpeakerSlider, Sponsors, Tickets } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* About section */}
        <Counter /> {/* Stats section */}
        <Services /> {/* Services section */}
        <WhyUs /> {/* Why choose us */}
        <SpeakerSlider /> {/* Speaker slider */}
        <Banner /> {/* Banner Section */}
        <Team /> {/* Team section */}
        <Testimonials /> {/* Client reviews */}
        <Tickets /> {/* Ticket info */}
        <VenueDetails reverseOrder={true} /> {/* Venue details */}
        <Sponsors /> {/* Sponsors section */}

      </section>

    </>
  );
}

export default AboutUs;